import { immediateToast as iziImmediateToast } from 'izitoast-react';

const toastIconByType: Record<string, string> = {
    success: 'fa-light fa-check-circle',
    error: 'fa-light fa-times-circle',
    warning: 'fa-light fa-exclamation-circle',
    info: 'fa-light fa-info-circle',
};

/**
 * Project-wide toast entry point.
 * Keep visual behavior consistent regardless of the caller options.
 */
export const immediateToast = (type: any, options: Record<string, any> = {}) => {
    return iziImmediateToast(
        type,
        {
            ...options,
            icon: options.icon ?? toastIconByType[String(type)],
            iconColor: '#FFFFFF',
            position: 'topRight',
            timeout: 4000,
            rtl: true,
            close: true,
            progressBar: true,
            pauseOnHover: true,
            closeOnClick: false,
        } as any,
    );
};
